import React from 'react';
import { alpha, Box } from '@mui/material';

/** The title with every case-insensitive occurrence of the query bold on a light tint. */
export function highlightMatches(title: string, query: string): React.ReactNode {
    const needle = query.trim().toLowerCase();
    if (!needle) {
        return title;
    }
    const parts: React.ReactNode[] = [];
    const haystack = title.toLowerCase();
    let from = 0;
    let at = haystack.indexOf(needle);
    while (at !== -1) {
        if (at > from) {
            parts.push(title.slice(from, at));
        }
        parts.push(
            <Box
                component="mark"
                key={at}
                data-test="concierge_recent_chat_match"
                sx={{
                    fontWeight: 600,
                    color: 'inherit',
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
                }}
            >
                {title.slice(at, at + needle.length)}
            </Box>,
        );
        from = at + needle.length;
        at = haystack.indexOf(needle, from);
    }
    if (from < title.length) {
        parts.push(title.slice(from));
    }
    return parts;
}
